import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { CuentaAbonoSubject } from 'src/app/global/services/cuenta-abono-subject.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';

@Component({
  selector: 'app-paso-tres',
  templateUrl: './paso-tres.component.html',
  styleUrls: ['./paso-tres.component.scss']
})
export class PasoTresComponent implements OnInit {

  @Output() nextSetp: EventEmitter<any> = new EventEmitter();
  isPersonaNatural: boolean = this.localStorageService.getPaso1Login().currentIsPersonaNatural;

  constructor(
    private cuentaAbonoSubject: CuentaAbonoSubject,
    private localStorageService: LocalStorageService,
    private tagManagerService: TagManagerService,
    private carroService: CarroComprasService

  ) { }

  dataPaso3: Paso3;

  ngOnInit() {
    this.tagManagerService.logPaso3(this.localStorageService.getPaso3(), this.localStorageService.getPaso1().currentIsPersonaNatural);
    this.tagManagerService.logEvent(GoogleTagManager.eventPageView().detallesContratacionConfirma());
    this.tagManagerService.logEvent(GoogleTagManager.eventAddShippingInfo().setEtiqueta(this.carroService.getCurrentProduct().title.toLowerCase()));

    if (this.localStorageService.getPaso3().tipoAprobacion.tipoAprobacion === 'ACEPTA_TERMINOS_Y_CONDICIONES') {
      this.cuentaAbonoSubject.showTerminosyCondiciones();
    } else {
      this.cuentaAbonoSubject.showAnexoContrato();
    }
  }

}
